module.exports = {"title":"Forgot your username?","content":"<p>To recover Username please speak with your organization's administrator or contact ShowTix4U Customer Service at 866-967-8167.</p>","goBack":"Go back to the Login page"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotUsername/locales/fr.json
// module id = 1759
// module chunks = 0